import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const PermutationCombination = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Query: Permutation and Combination"
    videos={[
        "https://www.youtube.com/embed/15McU9U1iew",
        "https://www.youtube.com/embed/TKFHceaqoog",
        "https://www.youtube.com/embed/fKAjPkdzCD4",
        "https://www.youtube.com/embed/laWXn3LJDOw"

      
    ]}
    takeaways={[]}
    questions={[
      "Find the number of positive integers that can be formed from the integers 1,3,5,7 and 9 in which no digit is repeated",
      "How many different ways are there to choose 3 donuts from the 5 varieties at a donut shop? Assume that there are at least 3 donuts of each variety.",
      "How many different ways are there to choose 3 coins from the collections of Rs 1 coins, Rs 2 coins, Rs 5 coins, Rs 10 coins? Assume that there are at least 3 coins of each denomination",
      "A multiple choice test has 25 questions and 4 options for each question. How many ways can the 15 questions be answered, so that i)Exactly 7 answers are correct ii)At least 3 answers are correct."
    ]}
    exampleVideos={[]}
  />
);
}

export default PermutationCombination;
